/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text,
  VStack,
  useDisclosure,
} from '@chakra-ui/react'
import {
  useAddReport,
  useLoadReportData,
  useUpdateDownloadCount,
} from '../../hooks/report.hooks'
import ReportData from './report-data'
import ReportFilter from './report-filter'
import { getCurrentDate } from '../../utils/date.utils'
import { sectionDetailedTrack } from '../repository/repo.utils'
import { GA_CATEGORY_DIALOG_BOX } from './../repository/repo.utils'
import { useLanguageContext } from '../../context/locale.context'

function ReportWorkspace() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [reportData, setReportData] = useState([])
  const [disable, setDisable] = useState(false)
  const [selectedReportId, setSelectedReportId] = useState(null)

  const { mutate: mutateLoadReport, isLoading: isLoadReportLoading } =
    useLoadReportData()
  const {
    state: { locale },
  } = useLanguageContext()
  const { mutate: mutateUpdateDownloadCount } = useUpdateDownloadCount()

  const {
    mutate: mutateAddReport,
    isLoading: isAddReportLoading,
    data: addData,
  } = useAddReport()

  useEffect(() => {
    loadReportsData()
  }, [])

  const loadReportsData = () => {
    mutateLoadReport(
      {},
      {
        onSuccess: data => {
          setReportData(data)
        },
      }
    )
  }

  const getMoreData = () => {
    if (!disable) {
      mutateLoadReport(
        { page_start: reportData.length },
        {
          onSuccess: data => {
            if (!!data.length) {
              setReportData([...reportData, ...data])
            } else {
              setDisable(true)
            }
          },
        }
      )
    }
  }

  const addReport = reportFilterValues => {
    setSelectedReportId(reportFilterValues.selectedReport.tag_type_id)
    mutateAddReport(reportFilterValues, {
      onSuccess: data => {
        if (data === 200) {
          onOpen()
          // mutateLoadReport();
          loadReportsData()
        }
      },
    })
  }

  const updateDownloadCount = rowData => {
    mutateUpdateDownloadCount(
      {
        log_datetime: getCurrentDate(),
        report_transaction_id: rowData.report_transaction_id,
        report_id: rowData.report_id,
      },
      {
        onSuccess: async data => {
          if (data?.data.status === 200) {
            loadReportsData()
          }
        },
      }
    )
  }

  return (
    <Box bg="secondary">
      <VStack spacing={4} align="stretch">
        <Box p="10px" background="white" borderRadius="md">
          <ReportFilter addReport={addReport} isLoading={isAddReportLoading} />
        </Box>
        <Box p="20px" background="white" borderRadius="md">
          <ReportData
            reportData={reportData}
            isLoading={isLoadReportLoading}
            getMoreData={getMoreData}
            disable={disable}
            updateDownloadCount={updateDownloadCount}
          />
        </Box>
      </VStack>
      <Modal isCentered isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {locale['Report Request successfully submitted.']}
          </ModalHeader>
          <ModalBody>
            {selectedReportId === 0 ? (
              [
              <Text>
                {
                  locale[
                    'It will be made available to you by 11 am tomorrow in this section'
                  ]
                }
              </Text>,
               <Text>
               {
                 locale[
                   'Note: This is once-a-month report available from 21st of the month for the preceding month'
                 ]
               }
             </Text>
              ]
            ) : (
              <Text>
                {
                  locale[
                    'Please visit Report List section after tomorrow morning 7 A.M.'
                  ]
                }
              </Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                sectionDetailedTrack({
                  category: GA_CATEGORY_DIALOG_BOX,
                  action: 'Report',
                  label: 'Close',
                })
                onClose()
              }}
            >
              {locale['Close']}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  )
}

export default ReportWorkspace
